import { useAppSelector as useSelector } from 'dux/app/hooks';

import { Box } from '@prose-ui';
import { styled } from '@prose-ui/legacy';

import Typography from 'Components/Typography';

import { formatPriceWithCurrency } from 'utils/currencies';

import {
  getCartTotalPriceV2,
  getCartTotalPriceWithTaxesV2,
  getCartTotalShippingV2,
  getCartV2Currency,
  getItemQuantityInCartV2,
} from 'dux/cartV2/selectors';
import { getIsOrderFree } from 'dux/user/selectors';

const MobileFooterOrderSumaryContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const OrderSummaryLabel = styled(Typography)`
  font-size: 12px;
  color: #000;
`;

const ChevronDown = styled.div`
  margin-top: 3px;
  margin-left: 8px;
  width: 7px;
  height: 7px;
  border-left: 1px solid;
  border-bottom: 1px solid black;
  transform: rotate(-45deg);
`;

const ChevronUp = styled(ChevronDown)`
  transform: rotate(135deg);
`;

type OrderSummaryHeader = {
  isCheckout: boolean;
  chevronDirection: 'up' | 'down';
};

const CheckoutSummaryHeaderV2 = ({ isCheckout = false, chevronDirection }: OrderSummaryHeader) => {
  const currency = useSelector(getCartV2Currency);

  const cartTotalPriceWithTaxes = useSelector(getCartTotalPriceWithTaxesV2);
  const cartTotalPrice = useSelector(getCartTotalPriceV2);
  const cartTotalShipping = useSelector(getCartTotalShippingV2);
  const freeOrder = useSelector(getIsOrderFree);

  const total = isCheckout ? cartTotalPriceWithTaxes : cartTotalPrice + cartTotalShipping;

  const productsInCartQuantity = useSelector(getItemQuantityInCartV2);

  const totalDisplay = freeOrder
    ? 'Free'
    : `${formatPriceWithCurrency({ price: total, currency })}`;

  return (
    <MobileFooterOrderSumaryContainer>
      <Box display="flex">
        {/* @ts-ignore Legacy Typography  */}
        <OrderSummaryLabel variant="mono3">
          {`Order summary [${productsInCartQuantity}]`}
        </OrderSummaryLabel>
        {chevronDirection === 'up' ? <ChevronUp /> : <ChevronDown />}
      </Box>
      {/* @ts-ignore Legacy Typography  */}
      <Typography>{totalDisplay}</Typography>
    </MobileFooterOrderSumaryContainer>
  );
};

export default CheckoutSummaryHeaderV2;
